module.exports = __webpack_public_path__ + "static/media/reward-en.47042aec.webp";